module.exports = __webpack_public_path__ + "static/img/btn.294ef6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/market/market107/btn.png
// module id = BtZ8
// module chunks = 1